window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views.index = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el;

        this.link = editor.link;
        this.data = opts.data || {};
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this, $descriptor = this.$('[data-page="index"]'), link = self.link;

        switch($descriptor.data('key')) {
            case 'p':
                self.editor.data.site = $descriptor.data('site');
                link.setProperty('site', $descriptor.data('site'));
                link.setProperty('structure', $descriptor.data('structure'));
                link.setProperty('documentId', $descriptor.data('document'));
                this.setMode('p');
                break;

            case 'l':
                self.editor.data.site = $descriptor.data('site');
                link.setProperty('library', $descriptor.data('library'));
                link.setProperty('nodeId', $descriptor.data('node'));
                link.setProperty('leafId', $descriptor.data('leaf'));
                link.setProperty('reference', $descriptor.data('reference'));
                this.setMode('l');
                break;

            case 'u':
                this.setMode('u');
                link.setProperty('moniker', $descriptor.data('moniker'));
                break;

            case 'm':
                var email = this.data.srchref || "";
                email = email.replace(/mailto\s*:\s*/, '');
                link.setProperty('mValue', email);
                this.setMode('m');
                break;

            case 'h':
                link.setProperty('hValue', this.data.srchref || "");
                this.setMode('h');
                break;
        }

        if (self.editor.data.site) {
            this.$('#contextSwitch select').find('[site="'+self.editor.data.site+'"]').attr('selected', 'selected');
        }

        if (this.data.titled) {
            this.$('#titleEditor').find('input').val(this.data.title || "");
            this.$('#titleEditor').show();
        }

        self.$el.on('click.npseditorlinksIndex', '[data-page="index"] [data-mode]', function() {
            self.setMode(this.value);
            self.link.setProperty('extension', this.getAttribute('data-ext') || null);
        });
        self.$el.on('change.npseditorlinksIndex', '#contextSwitch select', function() {
            var selected = this.options[this.selectedIndex];
            self.editor.data.site = selected.getAttribute('site');
        });

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksIndex');
        return this;
    };

    view.prototype.setMode = function (mode) {
        var self = this, link = self.link;

        switch (mode) {
            case 'h':
            case 'm':
                if (link.getProperty(mode+'Value')) {
                    self.$('#'+mode+'Editor').val(link.getProperty(mode+'Value'));
                }
                break;
            case 'p' :
                if (link.getProperty('structure')) {
                    self.$('#selectStructure').val(link.getProperty('structure'));
                }
                break;
            case 'l' :
                if (link.getProperty('library')) {
                    self.$('#selectLibrary').val(link.getProperty('library'));
                }
                break;
        }

        self.$('[name="linkType"]').each(function() {
            var $r = self.$('#mode_' + this.value);

            if (this.value===mode) {
                this.checked = true;
                $r.show();
            } else {
                $r.hide();
            }
        });

        link.setProperty('content', mode);
        this.editor.enableNext('index');
    };

    view.prototype.commit = function () {
        var self = this;

        if (self.data.titled) {
            self.link.setOption('title', self.$('#titleEditor').find('input').val());
        }

        var modes = {
            h: function() {
                var value = self.$('#hEditor').val();
                value = value.replace(/^(\s|&nbsp;)+/, '');
                value = value.replace(/(\s|&nbsp;)+$/, '');
                if (value.indexOf('://')==-1) {
                    value = 'https://' + value;
                }
                self.link.setProperty('hValue', value);
                self.link.setProperty('link', value);
            },
            m: function() {
                var value = self.$('#mEditor').val();
                self.link.setProperty('mValue', value);
                self.link.setProperty('link', 'mailto:'+value);
            },
            p: function() {
                var structure = self.$('#selectStructure').val() || null;
                self.link.setProperty('structure', structure);
            },
            l: function() {
                var libraryId = self.$('#selectLibrary').val();
                self.link.setProperty('library', libraryId);
            }
        };
        var mode = self.link.getProperty('content');
        mode && modes[mode] && modes[mode]();

        return this;
    };
    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);